import Browser from '@wetransfer/concorde-browser';
import { TrackJS } from 'trackjs';
import get from 'lodash/get';

import { WallpaperActions } from '../store/actions';

import { RotationService } from '../services/rotation-service';

import { Vast } from './vast';

import Dropzone from '@component/dropzone';
import Router from '@module/router';
import Store from '@app/store';
import Actions from '@app/action';

/**
 * BELOW YOU WILL FIND THE METHODS WE EXPOSE TO WALLPAPERS VIA THE wallpaper-api.
 * PLEASE KEEP IN MIND THAT THE NAME OF THE METHODS CANNOT BE CHANGED,
 * UNLESS WE UPDATE ALL RUNNING CAMPAIGNS. SINCE WALLPAPERS DEPEND ON THOSE
 * NAMES, THIS IS PRETTY MUCH A HARD CONTRACT BETWEEN EACH OTHER.
 */
const firstVisit = Date.now();
export const WallpaperApiMethods = {
  api_toggleDragOver() {
    Dropzone.show();
  },

  api_showDropZone() {
    Dropzone.show();
  },

  // DEPRECATED
  api_hideDropZone() {
    // There was a time, where we were able to hide the Dropzone from the iframe.
    // Since we removed the Dropzone animation, the visibility of the Dropzone
    // is managed by the Dropzone component itself.
  },

  // DEPRECATED
  api_addFiles() {
    // Files cannot be dropped onto the iframe, the Dropzone should always manage the files.
    // If it is still the case, ignore the files, and hide the overlay.
    TrackJS.track('DEPRECATED: api_addFiles was called');
    Dropzone.hide();
  },

  api_show() {
    // Show the elements of the user interface, like the transfer window
    // and navigation and the panel
    Store.dispatch(Actions.Layout.showUI());
  },

  api_hide() {
    // Hide all user interface elements, like the transfer window
    // and navigation and the panel. Allows wallpapers to be "fullscreen".
    Store.dispatch(Actions.Layout.hideUI());
  },

  api_openPanel(path, trk = '') {
    // Only open panels that really exist
    if (!path.match(/^\/(about|plus|products|sign-in)/i)) return;

    // Do we have tracking information?
    const params = trk ? { search: `trk=${trk}` } : {};
    Router.navigateTo(path, false, params);
  },

  api_pauseTimer() {
    Store.dispatch(WallpaperActions.pauseRotation());
  },

  api_resumeTimer() {
    const { wallpaper } = Store.getState();
    Store.dispatch(WallpaperActions.startOrResumeRotation(wallpaper));
  },

  api_resetTimer() {
    RotationService.reset();
  },

  api_change() {
    Store.dispatch(WallpaperActions.rotateWallpaper());
  },

  api_forceChange() {
    Store.dispatch(WallpaperActions.rotateWallpaper());
  },

  // DEPRECATED: use api_setAppTheme instead
  api_setWallpaperUIStyle(styles = {}) {
    Store.dispatch(Actions.Layout.setWallpaperUIStyle(styles));
  },

  api_setAppTheme(styles) {
    document.body.className = `${document.body.className} ${styles.className}`;
    const link = document.createElement('link');
    link.setAttribute('id', `wallpaper-theme-${styles.className}`);
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', styles.href);
    document.getElementsByTagName('head')[0].appendChild(link);
  },

  api_vast(eventName, videoUrl) {
    const {
      wallpaper: { creative },
    } = Store.getState();
    Vast.track(creative.vastTrackers, eventName, videoUrl);
  },

  api_getState(requester) {
    const { wallpaper } = Store.getState();
    return this.getCurrentState(wallpaper.creative, requester);
  },

  getCurrentState(creative, requester) {
    const { route, session, wallpaper } = Store.getState();

    // Get the position for Transfer and Navigation
    const transfer = document.querySelector('.transfer');
    const transferRect = transfer.getBoundingClientRect();
    const nav = document.querySelector('.nav');
    const navRect = nav.getBoundingClientRect();

    const ads_viewed = wallpaper.position - 1;

    return {
      _analytics: creative.scripts,
      ads_viewed,
      requester,
      geo: session.region,
      state: route.path.match(/download/) ? 'download' : 'upload',
      panel: route.isPanelOpen,
      language: session.language,
      time_on_site: (Date.now() - firstVisit) / 1000,
      remaining: RotationService.remainingTime || 30,
      user_agent: Browser.identity, // {platform, browser, version}
      _click: get(creative, 'meta.href'),
      position: {
        x: Math.round(transferRect.left),
        y: Math.round(transferRect.top),
        width: Math.round(transferRect.width),
        height: Math.round(transferRect.height),
      },
      nav_position: {
        x: Math.round(navRect.left),
        y: Math.round(navRect.top),
        width: Math.round(navRect.width),
        height: Math.round(navRect.height),
      },
    };
  },
};
